import { useEffect, useRef } from 'react';

import { mixpanelTrack } from '@revenuemarket/utils/mixpanel';
import useGetIntegratedScrapeStatus from '~hooks/queries/scraping/useGetIntegratedScrapeStatus';
import { useGetSettings } from '~hooks/queries/setting/query';
import { useCompanyId } from '~hooks/useCompanyId';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import useScrapeFloatingPanelStore from '~store/useScrapeFloatingPanelStore';

import checkIsOnboardingUser from './checkIsOnboardingUser';

const useAutoOpenScrapeFloatingPanel = () => {
  const { companyId } = useCompanyId();
  const { data: settingsData } = useGetSettings();
  const { data: scrapeStatusData } = useGetIntegratedScrapeStatus(companyId ?? '');
  const { openPanel, isOpen } = useScrapeFloatingPanelStore();
  const hasAutoOpened = useRef(false);

  const onboardingStep = settingsData?.Data?.data?.onboardingStep;
  const isOnboardingUser = checkIsOnboardingUser(onboardingStep);
  const overallStatus = scrapeStatusData?.Data?.data?.overallStatus;
  const isInProgress = overallStatus === 'IN_PROGRESS';

  useEffect(() => {
    if (hasAutoOpened.current || isOpen) {
      return;
    }

    if (isOnboardingUser && isInProgress) {
      hasAutoOpened.current = true;
      mixpanelTrack(MIXPANEL_EVENT.SCRAPE_FLOATING_PANEL.VIEW);
      openPanel();
    }
  }, [isInProgress, openPanel, isOpen, isOnboardingUser]);
};

export default useAutoOpenScrapeFloatingPanel;
